import { HttpGetOurWarehouseList } from '@/service/bespeak'

export default {
    data(){
        return {
            warehouseList: [],
        }
    },
    created() {
        HttpGetOurWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: `${item.code}(${item.title})`,
                    code: item.code
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
	computed: {
        options () {
            return {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                {
                    text: this.$t("global.common.recent_month", {
                        defaultValue: "最近一月",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 30
                        );
                        return [start, end];
                    },
                },
                {
                    text: this.$t("global.common.latest_quarter", {
                        defaultValue: "最近一季度",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 90
                        );
                        return [start, end];
                    },
                },
              ],
            };
        },
        getBillTypeList(){
            return [
                { value: 1, label: '仓储费' },
                { value: 0, label: '仓库作业费' },
                { value: 2, label: '快递费' },
            ]
        },
        getOrderList(){
            return [
                { value: 200, label: 'B2C销售出库' },
                { value: 400, label: '销售退货单' },
                { value: 401, label: '销售退货单-销毁' },
                { value: 410, label: '销售退货计划单' },
                { value: 417, label: '退货处理单-销毁' },
                { value: 418, label: '退货处理单-换标' },
                { value: 430, label: '入库单' },
                { value: 431, label: '无来源入库单' },
                { value: 330, label: '调拨入库单' },
                { value: 310, label: '调拨出库单' },
                { value: 130, label: '中转入库单' },
                { value: 120, label: '中转出库单' },
                { value: 100, label: '中转入库计划' },
                { value: 6001, label: '销毁单' },
                { value: 202, label: 'B2C-卡车' },
                { value: 203, label: 'B2C-卡车PO' },
                { value: 204, label: 'B2C-快递PO' },
                { value: 299, label: '拦截单-B2C' },
                { value: 2991, label: '拦截单-B2C卡车' },
                { value: 2992, label: '拦截单-B2C卡车PO' },
                { value: 2993, label: '拦截单-B2C快递PO' },
                { value: 420, label: '入库计划单' },
                { value: 490, label: '认领处理单' },
                { value: 491, label: '认领处理单-销毁' },
            ]
        },
        getInventoryTypeList(){
            return [
                { value: 0, label: '正常库存' },
                { value: 1, label: '不可售库存' },
            ]
        },
    }

}
